
// import React, { useState } from "react";
// import {
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   Box
// } from "@mui/material";
// import Tab4DailyEnergy from "./tab4DailyEnergy/Tab4DailyEnergy";
// import Tab4YearlyEnergy from "./tab4YearlyEnergy/Tab4YearlyEnergy";
// import InverterFullSizeDailyEnergy from "./InverterFullSizeDailyEnergy";

// export default function Tab4MonthlyEnergyTabs({ onFullScreen }) {
//   const [selectedTab, setSelectedTab] = useState("Monthly Yield");

//   const handleChange = (event) => {
//     setSelectedTab(event.target.value);
//   };

//   const radioTitle = (
//     <RadioGroup row value={selectedTab} onChange={handleChange}>
//       <FormControlLabel
//         value="Monthly Yield"
//         label="Monthly Yield (kWh)"
//         control={<Radio size="small" />}
//       />
      
//       <FormControlLabel
//         value="Today"
//         label="Today"
//         control={<Radio size="small" />}
//       />
//     </RadioGroup>
//   );

//   return (
//     <InverterFullSizeDailyEnergy title={radioTitle} onFullScreen={onFullScreen}>
//       {/* Tab Content */}
//       <Box sx={{ marginTop: "10px" }}>
//         {selectedTab === "Monthly Yield" && <Tab4YearlyEnergy />}
//         {selectedTab === "Today" && <Tab4DailyEnergy />}
//       </Box>
//     </InverterFullSizeDailyEnergy>
//   );
// }



// import React, { useState } from "react";
// import {
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   Box
// } from "@mui/material";
// import Tab4DailyEnergy from "./tab4DailyEnergy/Tab4DailyEnergy";
// import Tab4YearlyEnergy from "./tab4YearlyEnergy/Tab4YearlyEnergy";
// import InverterFullSizeDailyEnergy from "./InverterFullSizeDailyEnergy";
// import Tab4DailyYield from "./tab4DailyYield/Tab4DaiylYield";

// export default function Tab4MonthlyEnergyTabs({ onFullScreen }) {
//   const [selectedTab, setSelectedTab] = useState("Monthly Yield");

//   const handleChange = (event) => {
//     setSelectedTab(event.target.value);
//   };

//   const radioTitle = (
//     <RadioGroup row value={selectedTab} onChange={handleChange}>
//       <FormControlLabel
//         value="Monthly Yield"
//         label="Monthly Yield (kWh)"
//         control={<Radio size="small" />}
//       />
//        {/* <FormControlLabel
//         value="Daily Yield"
//         label="Daily Yield (kWh)"
//         control={<Radio size="small" />}
//       /> */}
//       <FormControlLabel
//         value="Today"
//         label="Today"
//         control={<Radio size="small" />}
//       />
//     </RadioGroup>
//   );

//   return (
//     <InverterFullSizeDailyEnergy title={radioTitle} onFullScreen={onFullScreen}>
//       {/* Tab Content */}
//       <Box sx={{ marginTop: "10px" }}>
//         {selectedTab === "Monthly Yield" && <Tab4YearlyEnergy />}
//         {/* {selectedTab === "Daily Yield" && <Tab4DailyYield />} */}
//         {selectedTab === "Today" && <Tab4DailyEnergy />}
//       </Box>
//     </InverterFullSizeDailyEnergy>
//   );
// }


// 3.

import React, { useRef, useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Box
} from "@mui/material";

import Tab4DailyEnergy from "./tab4DailyEnergy/Tab4DailyEnergy";
import Tab4YearlyEnergy from "./tab4YearlyEnergy/Tab4YearlyEnergy";
import InverterFullSizeDailyEnergy from "./InverterFullSizeDailyEnergy";
import DownloadJpegButton from "../../../../../../../components/downloadJpegButton/DownloadJpegButton";
import Tab4DailyTrend from "./Tab4DailyTrend/Tab4DailyTrend";
import Tab4SpecificYield from "./tab4SpecificYield/Tab4SpecificYield";


export default function Tab4MonthlyEnergyTabs({ onFullScreen }) {
  const [selectedTab, setSelectedTab] = useState("Monthly Yield");

  const monthlyRef = useRef(null);
  const todayRef = useRef(null);
  const dailyTrendRef = useRef(null);
  const specificYieldRef = useRef(null); // ✅ FIXED

  const handleChange = (event) => {
    setSelectedTab(event.target.value);
  };

  const radioTitle = (
    <RadioGroup row value={selectedTab} onChange={handleChange}>
      <FormControlLabel
        value="Monthly Yield"
        label="Monthly Yield (kWh)"
        control={<Radio size="small" />}
      />
      <FormControlLabel
        value="Today"
        label="Today"
        control={<Radio size="small" />}
      />
      <FormControlLabel
        value="Daily Trend"
        label="Daily Trend"
        control={<Radio size="small" />}
      />
      <FormControlLabel
        value="Specific Yield"
        label="Specific Yield"
        control={<Radio size="small" />}
      />
    </RadioGroup>
  );

  // ✅ Correct active ref logic
  const activeRef =
    selectedTab === "Monthly Yield"
      ? monthlyRef
      : selectedTab === "Today"
      ? todayRef
      : selectedTab === "Daily Trend"
      ? dailyTrendRef
      : specificYieldRef;

  return (
    <InverterFullSizeDailyEnergy title={radioTitle} onFullScreen={onFullScreen}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 0 }}>
        <DownloadJpegButton
          targetRef={activeRef}
          fileName={`${selectedTab.replace(/\s+/g, "")}.jpeg`}
        />
      </Box>

      <Box sx={{ marginTop: "10px" }}>
        {selectedTab === "Monthly Yield" && (
          <Tab4YearlyEnergy ref={monthlyRef} />
        )}

        {selectedTab === "Today" && (
          <Tab4DailyEnergy ref={todayRef} />
        )}

        {selectedTab === "Daily Trend" && (
          <Tab4DailyTrend ref={dailyTrendRef} />
        )}

        {selectedTab === "Specific Yield" && (
          <Tab4SpecificYield ref={specificYieldRef} />
        )}
      </Box>
    </InverterFullSizeDailyEnergy>
  );
}
